import styled from "styled-components";

export const ShapeContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 1024px) {
    display: none;
  }
`;
export const ShapeWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;
export const ShapeBox = styled.div`
  width: ${(props) => props.width};
  background: ${(props) => props.backGroundColor};
  border-top-left-radius: ${(props) => props.borderTopLeftRadius};
  border-top-right-radius: ${(props) => props.borderTopRightRadius};
  border-bottom-left-radius: ${(props) => props.borderBottomLeftRadius};
  border-bottom-right-radius: ${(props) => props.borderBottomRightRadius};
  border: ${(props) => props.border};
  height: ${(props) => props.height};
  display: flex;
  align-items: center;
  justify-content: center;
  &.marginRight {
    margin-right: 22px;
    @media (max-width: 1064px) {
      margin-right: 10px;
    }
  }
`;

export const ShapeImgWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  & div:first-child {
    position: relative;
    bottom: 10px;
  }
  & div:last-child {
    z-index: 20;
    position: relative;
    right: 60px;
  }
`;
